import { StrictMode, Suspense, lazy } from 'react';
import { render, createPortal } from 'react-dom';
// import { BrowserRouter as Router, Route } from 'react-router-dom';
import LoadingAnim from './UIComponents/LoadingAnim';
import ErrorBoundary from './helpers/ErrorBoundary';
import UIStore from './hooks/store/ui';
import TicketsStore from './hooks/store/tickets';
import CalendarStore from './hooks/store/calendar';
import RedemptionStore from './hooks/store/redemption';

import 'bootstrap/dist/css/bootstrap.min.css';

UIStore();
TicketsStore();
CalendarStore();
RedemptionStore();

const Redemption = lazy(() => import('./containers/Redemption'));
const Ticketing = lazy(() => import('./containers/Ticketing'));
const Timer = lazy(() => import('./components/Timer'));

const App = ({ hash }) => {
  return (
    <Suspense fallback={<LoadingAnim />}>
      <Ticketing hash={hash} />
    </Suspense>
  );
}

// const App = ({ hash, forwardRef }) => {
//   return (
//     <Router>
//       <Suspense fallback={<LoadingAnim/>}>
//         <Route path="/ticketing" render={(props) => <Ticketing {...props} hash={hash} />} />
//       </Suspense>
//     </Router>
//   );
// }

// Split location into `/` separated parts, then render `Application` with it
const hash = window.location.hash.replace(/^#\/?|\/$/g, '').split('/');
// let section = hash[0] === '' ? 'studio-tour' : hash[0];

const el = document.getElementById('booking');
if (el) {
  handleNewHash();
  // window.addEventListener('hashchange', handleNewHash, false);
}

function handleNewHash() {
  const section = hash[0] ? hash[0] : '';
  sessionStorage.setItem('section', section);
  render(<ErrorBoundary><App /></ErrorBoundary>, el);
}

const timerElement = document.getElementById('timer');
if (timerElement) {
  render(<Suspense fallback={<LoadingAnim />}><Timer /></Suspense>, timerElement);
}

const redemptionEl = document.getElementById('giftRedemption');
if (redemptionEl) {
  render(<Suspense fallback={<LoadingAnim />}><Redemption /></Suspense>, redemptionEl);
}

export default App;
